export const FORM_FIELD_STATE =[
      {
    id: "paymentMethod",
    label: "Payment Method",
    placeHolder: "",
    type: "text",
    md: 4,
    inputProps: {
      maxLength: 50,
    },
    disabled: true,
    prefixIcon: "£",
  },
  {
    id:'contentValue',
    label:'Content Value',
    placeHolder:'',
    type:'text',
    md:4,
    inputProps:{
        maxLength:50,
    },
    disabled:false,
    prefixIcon:'£',
  },
  
] 

export const CUSTOMER_NOTES = [
  {
    id: "quoteNote",
    label: "Quote Note (for customers)",
    tooltipText: "Quote Note (for customers)",
    placeHolder: "",
    type: "textarea",
    // firstColmd: 3,
    md: 12,
    minRows: 2,
    inputProps: {
      maxLength: 250,
    },
  },
  
];